/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  FormControlLabel,
  Button,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useNavigate } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import TableSkeleton from '../../components/common/TableSkeleton';
import PrivateWrapper from '../../layouts/Private';
import {
  changeAffiliateStatus,
  getAffiliatesWithStatus,
  getAllAffiliates,
  proccessPayments,
} from '../../services/Affiliates';
import { affiliateStatus } from '../../configs/Constants';
import RoutePaths from '../../configs/Routes';
import ApprovalDialog from '../../components/affiliates/ApprovalDialog';
import ConfirmDialog from '../../components/common/ConfirmDialog';
import Status from '../../components/common/DataStatus';
import useToastr from '../../hooks/useToastr';
import ManageCommissionFormDialog from '../../components/affiliates/ManageCommissionForm';

const AffiliateList = ({ type }) => {
  const pageName =
    type === affiliateStatus.PENDING
      ? 'Affiliates- Pending Approvals'
      : type === affiliateStatus.APPROVED
      ? 'Approved Affiliates '
      : 'Affiliates';

  const { showErrorToastr, showSuccessToastr } = useToastr();

  const [rows, setRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openCommissionDialog, setOpenCommissionDialog] = useState(false);
  const [processing, setProcessing] = useState(false);

  const [selectedAgentsForPayment, setSelectAgentsForPayment] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [reloadRows, setReloadRows] = useState(false);
  // const [activePage, setActivePage] = useState(1);
  // const [totalPages, setTotalPages] = useState(0);

  const columns = [
    { name: 'Name', id: 'name', width: '15%' },
    { name: 'Email', id: 'email', width: '20%' },
    { name: 'Promocodes', id: 'promocodes', width: '15%' },
    { name: 'Commission (%)', id: 'created', width: '5%', align: 'right' },
    {
      name: 'Monthly Commission\n(current)',
      id: 'currentMonthCommission',
      width: '15%',
      align: 'right',
    },
    { name: 'Status', id: 'status', width: '5%', align: 'center' },
    { name: 'Actions', id: 'action', width: '5%', align: 'center' },
  ];

  const handleOpenApprovalDialog = (id) => {
    setSelectedId(id);
    setOpenApprovalDialog(true);
  };

  const handleOpenConfirmDialog = (id) => {
    setSelectedId(id);
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setSelectedId(null);
    setOpenConfirmDialog(false);
  };

  const handleRejectAffliate = async () => {
    try {
      setProcessing(true);
      if (selectedId) {
        await changeAffiliateStatus(selectedId, affiliateStatus.DISAPPROVED);
      }
      showSuccessToastr('Affiliate rejected successfully.');
      handleCloseConfirmDialog();
      setReloadRows(!reloadRows);
    } catch (error) {
      showErrorToastr(error?.response?.data?.message || error?.message || 'Something went wrong.');
      setProcessing(false);
    }
  };

  const handleSuccessCloseAprovalDialog = () => {
    setSelectedId(null);
    setOpenApprovalDialog(false);
    setReloadRows(!reloadRows);
  };

  const handleCloseAprovalDialog = () => {
    setSelectedId(null);
    setOpenApprovalDialog(false);
  };

  const handleSuccessCloseCommissionDialog = () => {
    setSelectedId(null);
    setOpenCommissionDialog(false);
    setReloadRows(!reloadRows);
  };

  const handleCloseCommissionDialog = () => {
    setSelectedId(null);
    setOpenCommissionDialog(false);
  };

  useEffect(() => {
    setProcessing(false);
    setDataLoaded(false);
    setSelectAllChecked(false);
    setSelectAgentsForPayment({});
    if (Number(type) !== -1) {
      getAffiliatesWithStatus(type)
        .then((res) => {
          setRows(
            res.map((r) => ({
              id: r.id,
              name: `${r.firstName}  ${r.lastName}`,
              email: r.email,
              type: r.type,
              phone: r.phoneNumber,
              status: r.status,
              currentMonthCommission: '-',
              commissionPercentages: r?.commissionPercentages
                ? Array.isArray(r.commissionPercentages)
                  ? r.commissionPercentages.join(', ')
                  : '-'
                : '-',
              promocodes: r?.promocodes
                ? Array.isArray(r.promocodes)
                  ? r.promocodes.join(', ')
                  : '-'
                : '-',
            }))
          );
          // setTotalPages(res.data.totalPages);
          setDataLoaded(true);
        })
        .catch(() => {
          setRows([]);
          setDataLoaded(true);
        });
    } else {
      getAllAffiliates()
        .then((res) => {
          setRows(
            res.map((r) => ({
              id: r.id,
              name: `${r.firstName}  ${r.lastName}`,
              email: r.email,
              type: r.type,
              phone: r.phoneNumber,
              status: r.status,
              currentMonthCommission: '-',
              commissionPercentages: r?.commissionPercentages
                ? Array.isArray(r.commissionPercentages)
                  ? r.commissionPercentages.join(', ')
                  : '-'
                : '-',
              promocodes: r?.promocodes
                ? Array.isArray(r.promocodes)
                  ? r.promocodes.join(', ')
                  : '-'
                : '-',
            }))
          );
          // setTotalPages(res.data.totalPages);
          setDataLoaded(true);
        })
        .catch(() => {
          setRows([]);
          setDataLoaded(true);
        });
    }
  }, [type, reloadRows]);

  const handleSelectAll = (event) => {
    const t = { ...selectedAgentsForPayment };
    if (event.target.checked) {
      rows.forEach((r) => {
        t[r.id] = true;
      });
      setSelectAgentsForPayment(t);
      setSelectAllChecked(true);
    } else {
      setSelectAgentsForPayment({});
      setSelectAllChecked(false);
    }
  };

  const handlePayments = async () => {
    if (Object.keys(selectedAgentsForPayment).length > 0) {
      // TODO: integrate service
      const responsePayment = await proccessPayments(selectedAgentsForPayment);
      if (responsePayment.status === 200) showSuccessToastr('Payment Done Successfully.');
      else showErrorToastr(`Something Went Wrong: ${responsePayment.msg}`);
    } else {
      showErrorToastr('Please select agents to process payments.');
    }
  };

  const handleCommissionUpdate = (id) => {
    setSelectedId(id);
    setOpenCommissionDialog(true);
  };

  const handleCheckBoxChange = (event, id) => {
    const t = { ...selectedAgentsForPayment };
    if (event.target.checked) {
      t[id] = true;
      setSelectAgentsForPayment(t);
    } else {
      if (id in t) {
        delete t[id];
      }
      setSelectAgentsForPayment(t);
    }
    if (Object.keys(t).length === rows.length) {
      setSelectAllChecked(true);
    } else {
      setSelectAllChecked(false);
    }
  };

  return (
    <PrivateWrapper pageName={pageName}>
      <Box px={2}>
        <Box display="flex" mt={4}>
          {type === affiliateStatus.APPROVED && (
            <>
              <div />
              <Box ml="auto">
                <Button variant="contained" disableElevation onClick={handlePayments}>
                  Process Payments
                </Button>
              </Box>
            </>
          )}
        </Box>
        <TableContainer sx={{ my: 2 }}>
          <Table aria-label="simple table">
            <TableHead sx={{ bgcolor: '#E8E8E8' }}>
              <TableRow>
                {type === affiliateStatus.APPROVED && (
                  <TableCell width="5%">
                    <FormControlLabel
                      control={<Checkbox onChange={handleSelectAll} checked={selectAllChecked} />}
                    />
                  </TableCell>
                )}
                {columns.map((col) => (
                  <TableCell width={col.width} align={col.align || 'left'} key={`col-${col.id}`}>
                    {col.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!dataLoaded && <TableSkeleton cols={type === affiliateStatus.APPROVED ? 8 : 7} />}
              {dataLoaded && rows.length === 0 && (
                <TableCell
                  align="center"
                  size="medium"
                  colSpan={type === affiliateStatus.APPROVED ? 8 : 7}
                >
                  No records found
                </TableCell>
              )}
              {dataLoaded &&
                rows.map((row) => (
                  <TableRow key={`sb-${row.id}`}>
                    {type === affiliateStatus.APPROVED && (
                      <TableCell width="5%">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={row.id in selectedAgentsForPayment}
                              onChange={(e) => {
                                handleCheckBoxChange(e, row.id);
                              }}
                            />
                          }
                        />
                      </TableCell>
                    )}
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.email}</TableCell>
                    <TableCell>{row.promocodes}</TableCell>
                    <TableCell align="right">{row.commissionPercentages}</TableCell>
                    <TableCell align="right">{row.currentMonthCommission}</TableCell>
                    <TableCell>
                      <Status value={row.status} statusFor="affiliate" />
                    </TableCell>
                    <TableCell>
                      <AffiliateActions
                        type={type}
                        affiliateId={row.id}
                        approveAffiliate={handleOpenApprovalDialog}
                        rejectAffiliate={() => {
                          handleOpenConfirmDialog(row.id);
                        }}
                        handleCommissionUpdate={handleCommissionUpdate}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {openApprovalDialog && (
          <ApprovalDialog
            title="Approval Details"
            onClose={handleCloseAprovalDialog}
            onSave={handleSuccessCloseAprovalDialog}
            editId={selectedId}
          />
        )}

        {openConfirmDialog && (
          <ConfirmDialog
            title="Reject Affiliate"
            message="Are you sure want to reject selected affiliate?"
            confirmBtnText="Reject"
            onClose={handleCloseConfirmDialog}
            onConfirm={handleRejectAffliate}
            editId={selectedId}
            processing={processing}
          />
        )}

        {openCommissionDialog && (
          <ManageCommissionFormDialog
            onClose={handleCloseCommissionDialog}
            onSave={handleSuccessCloseCommissionDialog}
            editId={selectedId}
          />
        )}

        {/* {dataLoaded && totalPages > 1 && (
          <Pagination
            count={totalPages}
            showFirstButton
            showLastButton
            onChange={(_, pageNumber) => {
              setActivePage(pageNumber);
              setReloadRows(!reloadRows);
            }}
            page={activePage}
          />
        )} */}
      </Box>
    </PrivateWrapper>
  );
};

const AffiliateActions = ({
  type,
  affiliateId,
  approveAffiliate,
  rejectAffiliate,
  handleCommissionUpdate,
}) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  if (type === affiliateStatus.PENDING) {
    return (
      <Box display="flex">
        <IconButton
          onClick={() => {
            approveAffiliate(affiliateId);
          }}
        >
          <DoneIcon color="success" />
        </IconButton>
        <IconButton>
          <ClearIcon
            color="error"
            onClick={() => {
              rejectAffiliate(affiliateId);
            }}
          />
        </IconButton>
      </Box>
    );
  }

  return (
    <>
      <div>
        <IconButton aria-label="more" id="long-button" aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem
            key="view"
            onClick={() => {
              navigate(RoutePaths.AFFILIATE_DETAILS.replace(':id', affiliateId));
            }}
          >
            View
          </MenuItem>
          <MenuItem
            key="update-commission"
            onClick={() => {
              handleCommissionUpdate(affiliateId);
            }}
          >
            Update Commission
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};

AffiliateActions.defaultProps = {
  type: -1, // all
};

AffiliateActions.propTypes = {
  type: PropTypes.number,
  affiliateId: PropTypes.string.isRequired,
  approveAffiliate: PropTypes.func.isRequired,
  rejectAffiliate: PropTypes.func.isRequired,
  handleCommissionUpdate: PropTypes.func.isRequired,
};

AffiliateList.defaultProps = {
  type: -1, // all
};

AffiliateList.propTypes = {
  type: PropTypes.number,
};

export default AffiliateList;
